// src/components/breadcrumbs/breadcrumbs.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  fragment BreadcrumbItemFragment on BreadcrumbItem {\n    text\n    uiLinkAction {\n      resource {\n        value\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  fragment BreadcrumbsStructuredDataFragment on Breadcrumbs {\n    seoStructuredData\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  query BreadcrumbsQuery($context: ContextInput!, $uriContext: UriContextInput!) {\n    breadcrumbs(context: $context, uriContext: $uriContext) {\n      breadcrumbItems {\n        ...BreadcrumbItemFragment\n      }\n      ...BreadcrumbsStructuredDataFragment\n      impressionAnalytics {\n        event\n        referrerId\n      }\n      menuAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
import React3 from "react";
import { gql as gql3, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker, useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkBreadcrumbs } from "uitk-react-breadcrumbs";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing } from "uitk-react-spacing";
// src/components/breadcrumbs/__private/__fragments/breadcrumb-item.tsx
import React from "react";
import { gql } from "@apollo/client";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLink } from "uitk-react-link";
var __BreadcrumbItemFragment = gql(_templateObject());
var BreadcrumbItem = function(param) {
    var data = param.data, className = param.className;
    var uiLinkAction = data.uiLinkAction, text = data.text;
    var clickTracker = useClickTracker();
    if (!text) {
        return null;
    }
    if (uiLinkAction) {
        var analytics = uiLinkAction.analytics, resource = uiLinkAction.resource;
        var onClickCapture = function() {
            clickTracker(analytics.referrerId, analytics.linkName);
        };
        return /* @__PURE__ */ React.createElement(UitkLink, {
            className: className,
            onClickCapture: onClickCapture,
            inline: true,
            theme: "default",
            size: "small"
        }, /* @__PURE__ */ React.createElement("a", {
            href: resource.value,
            rel: "noopener noreferrer"
        }, text));
    }
    return /* @__PURE__ */ React.createElement("span", {
        className: className
    }, text);
};
BreadcrumbItem.displayName = "BreadcrumbItem";
BreadcrumbItem.fragment = __BreadcrumbItemFragment;
// src/components/breadcrumbs/__private/__fragments/structured-data.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
var __BreadcrumbsStructuredDataFragment = gql2(_templateObject1());
var BreadcrumbsStructuredData = function(param) {
    var data = param.data;
    var structuredData = data.seoStructuredData;
    if (!structuredData) {
        return null;
    }
    return /* @__PURE__ */ React2.createElement("script", {
        "data-stid": "breadcrumbs-structured-data",
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: structuredData
        }
    });
};
BreadcrumbsStructuredData.fragment = __BreadcrumbsStructuredDataFragment;
BreadcrumbsStructuredData.displayName = "BreadcrumbsStructuredData";
// src/components/breadcrumbs/breadcrumbs.tsx
var __Query = gql3(_templateObject2(), BreadcrumbItem.fragment, BreadcrumbsStructuredData.fragment);
var Breadcrumbs = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr;
    var context = useBexApi().context;
    var _React3_useState = _slicedToArray(React3.useState(false), 2), isMenuOpen = _React3_useState[0], setMenuOpen = _React3_useState[1];
    var clickTracker = useClickTracker2();
    var variables = _objectSpreadProps(_objectSpread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading || error || !data || !data.breadcrumbs) {
        return null;
    }
    var breadcrumbs = data.breadcrumbs;
    var breadcrumbItems = breadcrumbs.breadcrumbItems, impressionAnalytics = breadcrumbs.impressionAnalytics, menuAnalytics = breadcrumbs.menuAnalytics;
    if (breadcrumbItems.length === 0) {
        return null;
    }
    var menuAnalyticsConfig = menuAnalytics ? {
        id: menuAnalytics.referrerId,
        description: menuAnalytics.linkName,
        callback: function() {
            clickTracker(menuAnalytics.referrerId, menuAnalytics.linkName);
        }
    } : void 0;
    var onBreadcrumbsMenuTriggerClick = function() {
        setMenuOpen(function(prevState) {
            return !prevState;
        });
    };
    var breadcrumbList = breadcrumbItems.map(function(breadcrumbItem, index) {
        return /* @__PURE__ */ React3.createElement(BreadcrumbItem, {
            key: "breadcrumb-".concat(index),
            data: breadcrumbItem
        });
    });
    return /* @__PURE__ */ React3.createElement(React3.Fragment, null, /* @__PURE__ */ React3.createElement(IntersectionTracker, {
        trackOnce: true,
        referrerId: impressionAnalytics.referrerId,
        linkName: impressionAnalytics.event
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlex, {
        justifyContent: "space-between",
        alignItems: "center"
    }, /* @__PURE__ */ React3.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React3.createElement(Viewport, null, /* @__PURE__ */ React3.createElement(ViewSmall, null, /* @__PURE__ */ React3.createElement(UitkSpacing, {
        padding: {
            blockstart: "one"
        }
    }, /* @__PURE__ */ React3.createElement(UitkBreadcrumbs, {
        crumbs: breadcrumbList,
        isOpen: isMenuOpen,
        onTriggerClick: onBreadcrumbsMenuTriggerClick,
        menuAnalytics: menuAnalyticsConfig
    }))), /* @__PURE__ */ React3.createElement(ViewMedium, null, /* @__PURE__ */ React3.createElement(UitkSpacing, {
        padding: {
            block: "two"
        }
    }, /* @__PURE__ */ React3.createElement(UitkBreadcrumbs, {
        crumbs: breadcrumbList,
        hasDynamicInlineCrumbs: true
    }))))))), /* @__PURE__ */ React3.createElement(BreadcrumbsStructuredData, {
        data: breadcrumbs
    }));
};
Breadcrumbs.displayName = "Breadcrumbs";
export { Breadcrumbs };
//# sourceMappingURL=index.js.map